<template>
  <div class="contain">
    <van-list
      class="vanList"
      v-model="loading"
      offset="10"
      :finished="finished"
      finished-text="没有更多了 ~"
      @load="onLoad"
      :immediate-check="false"
    >
      <div v-for="(item, index) in List" :key="index" class="Box">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
          "
        >
          <div class="time">{{ item.createTime }}</div>
          <div class="li" v-if="item.isAnonymous == 1">匿名</div>
          <div class="li" v-if="item.isAnonymous == 0">公开</div>
        </div>

        <div class="content">
          {{ item.content }}
        </div>
        <div class="reply" v-if="item.replyContent">
          <span style="color: #f4bf41">店铺回复：</span>{{ item.replyContent }}
        </div>

        <div class="box">
          <div>
            <img
              :src="item.goodsImg.split(',')[0]"
              alt=""
              style="
                width: 49px;
                height: 49px;
                border-radius: 6px;
                object-fit: cover;
              "
            />
          </div>
          <div class="title van-multi-ellipsis--l2">{{ item.goodsName }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { listOrderComment } from "@/api/Hotel";
import { getOpenId, getPlatform } from "@/utils/auth";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      List: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      page: 1,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getList() {
      listOrderComment({
        userId: getOpenId(),
        platformId: getPlatform(),
        pageSize: 10,
        pageNum: this.page,
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.List = this.List.concat(rows);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      this.page = this.page + 1;
      this.getList();
    },
  },
  created() {},
  mounted() {
    this.getList();
  },
};
</script> 

<style scoped>
.contain {
  padding: 10px;
  box-sizing: border-box;
}

.time {
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.Box {
  border-bottom: 1px solid #f9f9f9;
}
.li {
  font-size: 11px;
  font-family: PingFang SC;
  color: #999999;
  background-color: #f4f4f4;
  padding: 4px 16px;
  border-radius: 18px;
}

.content {
  margin-top: 6px;
  font-family: PingFang SC;
  color: #232323;
}

.box {
  margin: 10px 0;
  background-color: #f7f7f7;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.title {
  margin-left: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  color: #999999;
}

.reply {
  margin-top: 6px;
  font-size: 12px;
  font-family: PingFang SC;
}
</style>